import { createContext, useContext, useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { supabase } from './supabaseClient';
import auth from './firebaseClient';


const AuthContext = createContext();

async function upsertUser(user) {
  if (!user) return;

  const { data, error } = await supabase
    .from('users')
    .insert([{ id: user.uid, user_email: user.email }], { upsert: true });

  // if (error) {
  //   console.error('Error upserting user:', error.message);
  // }
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      setLoading(false);

      // Add/update user in Supabase upon sign-in
      upsertUser(user);
    });

    return () => unsubscribe();
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading }}>
      {children}
    </AuthContext.Provider>
  );
}


export function useAuth() {
  return useContext(AuthContext);
}